import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@instructure/canvas-theme'
import theme from '@instructure/canvas-theme'
theme.use()




ReactDOM.render((
  <App />
), document.getElementById('root'));

